import React from 'react';

import Icon from 'components/atoms/icon';
import Link, { LinkUrlType } from 'components/atoms/link';
import Typography from 'components/atoms/typography';

import { useScreenService } from 'hooks/use-screen-service';

import {
  StyledContent,
  StyledContentWrapper,
  StyledDepartment,
  StyledDepartments,
  StyledDepartmentsSection,
  StyledDescription,
  StyledMapDesktop,
  StyledMapMobile,
  StyledTitle,
  StyledWrapper,
  StyledWrapperArrowText,
} from './our-departments.styles';

export type DepartmentType = {
  name: string;
  link: LinkUrlType;
  positionx: number;
  positiony: number;
};

export type MapType = {
  departmentsList: DepartmentType[];
};

export type OurDepartmentsType = {
  heading: string;
  description: string;
  departmentsList: DepartmentType[];
} & PaddingType;
export type PaddingType = {
  isSmallPadding?: boolean;
};

const OurDepartments = ({
  heading,
  description,
  departmentsList,
  isSmallPadding,
}: OurDepartmentsType) => {
  const { isLgUp } = useScreenService();
  let currentLanguage = 'PL';
  if (typeof window !== 'undefined') {
    if (window.location.pathname.includes('/en/')) {
      currentLanguage = 'EN';
    }
  }
  const textSeeMore = currentLanguage === 'PL' ? 'Pokaż szczegóły' : 'Find out more';
  return (
    <StyledWrapper isSmallPadding={isSmallPadding}>
      <StyledContentWrapper>
        <StyledContent>
          <StyledDepartmentsSection>
            <StyledTitle variant="title2" color="gray100" component="h2">
              {heading}
            </StyledTitle>
            <StyledDescription variant="body1" color="gray80" html={description} />
            {!isLgUp && departmentsList ? (
              <StyledMapMobile departmentsList={departmentsList} />
            ) : null}
            {departmentsList ? (
              <StyledDepartments>
                {departmentsList.map(({ link, name }) => (
                  <Link internal={link.internal} ariaLabel={name}>
                    <StyledDepartment>
                      <Typography variant="title3" component="h3">
                        {name}
                      </Typography>
                      <StyledWrapperArrowText>
                        {/* TODO get html text from WP */}
                        <Typography
                          className="text-animation"
                          variant="body2"
                          color="primary50"
                          html={textSeeMore}
                        />
                        <Icon name="arrow-right" />
                      </StyledWrapperArrowText>
                    </StyledDepartment>
                  </Link>
                ))}
              </StyledDepartments>
            ) : null}
          </StyledDepartmentsSection>
          {isLgUp && departmentsList ? (
            <StyledMapDesktop departmentsList={departmentsList} />
          ) : null}
        </StyledContent>
      </StyledContentWrapper>
    </StyledWrapper>
  );
};

export default OurDepartments;
